import { createReducer, on } from '@ngrx/store';
import { ReportsActions, RouterActions } from '@actions/index'
import { ReportSettingsModel, RatingPerLocationModel, StarsDistributionPerLocationModel, ReviewCountPerLocationModel, FeedbackCountPerLocationModel, SendEngineEfficiencyPerLocationModel, AvergeContactSpeedPerLocationModel, FeedbackReviewPercentagePerLocationModel, ReviewPerReviewSitePerLocationModel, SentimentCheckCountPerLocationModel, CampaignMetricsPerLocationModel, ClickedOnReviewPerLocationModel, GeneratedReportsModel, ScheduledReportModel } from '@models/index'
import { emptyReportsSettingsModel } from '@utilities/data-utils';
import { RatingPerReviewSitePerLocationModel } from '@models/ratingPerReviewSitePerLocation.model';
import { SentReviewRequestCountPerLocationModel } from '@models/sentReviewRequestCountPerLocation.model';

export interface State {
    totalgeneratedReports: number;
    reportsSettings: ReportSettingsModel;
    rating: RatingPerLocationModel[];
    starsCount: StarsDistributionPerLocationModel[];
    reviewCount: ReviewCountPerLocationModel[];
    feedbackCount: FeedbackCountPerLocationModel[];
    clickedOnReviewCount: ClickedOnReviewPerLocationModel[];
    sendEngineEfficiency: SendEngineEfficiencyPerLocationModel[];
    averageContactSpeed: AvergeContactSpeedPerLocationModel[];
    feedbackReviewPercentage: FeedbackReviewPercentagePerLocationModel[];
    reviewsPerReviewSite: ReviewPerReviewSitePerLocationModel[];
    ratingPerReviewSite: RatingPerReviewSitePerLocationModel[];
    sentRequestCount: SentReviewRequestCountPerLocationModel[];
    sentimentCheckCount: SentimentCheckCountPerLocationModel[];
    campaignMetrics: CampaignMetricsPerLocationModel[];
    generalReportDateRange: {
        startTime: number;
        endTime: number;
    };
    generatedReports: GeneratedReportsModel[];
    scheduledReports: ScheduledReportModel[];
    error: string;
}


const initialState: State = {
    totalgeneratedReports: 0,
    reportsSettings: emptyReportsSettingsModel(),
    rating: [],
    starsCount: [],
    reviewCount: [],
    feedbackCount: [],
    clickedOnReviewCount: [],
    sendEngineEfficiency: [],
    averageContactSpeed: [],
    feedbackReviewPercentage: [],
    reviewsPerReviewSite: [],
    ratingPerReviewSite: [],
    sentRequestCount: [],
    sentimentCheckCount: [],
    campaignMetrics: [],
    generalReportDateRange: {
        startTime: new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),
        endTime: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0, 23, 59, 59).getTime()
    },
    generatedReports: [],
    scheduledReports: [],
    error: ''
};

export const reducer = createReducer(
    initialState,
    on(ReportsActions.saveReportsSettingsByBusinessSuccess, (state, { reportsSettings }) => ({ ...state, reportsSettings })),
    on(ReportsActions.generateReportSuccess, (state, { generatedReport }) => ({ ...state, generatedReports: [generatedReport, ...state.generatedReports], totalgeneratedReports: state.totalgeneratedReports + 1 })),
    on(ReportsActions.deleteGeneratedReportSuccess, (state, { deletedReportId }) => ({ ...state, generatedReports: state.generatedReports.filter((report)=>report.id!=deletedReportId.data), totalgeneratedReports: state.totalgeneratedReports - 1})),
    on(ReportsActions.searchGeneratedReportsSuccess, (state, { total, data }) => ({ ...state, generatedReports: data, totalgeneratedReports: total })),
    on(ReportsActions.getReportsSettingsByBusinessSuccess, (state, { reportsSettings }) => ({ ...state, reportsSettings })),
    on(ReportsActions.getRatingPerLocationSuccess, (state, { ratingPerLocation }) => ({ ...state, rating: ratingPerLocation })),
    on(ReportsActions.getStarsCountPerLocationSuccess, (state, { starsCountPerLocation }) => ({ ...state, starsCount: starsCountPerLocation })),
    on(ReportsActions.getReviewsPerLocationSuccess, (state, { reviewsPerLocation }) => ({ ...state, reviewCount: reviewsPerLocation })),
    on(ReportsActions.getFeedbacksPerLocationSuccess, (state, { feedbacksPerLocation }) => ({ ...state, feedbackCount: feedbacksPerLocation })),
    on(ReportsActions.getClickedOnReviewPerLocationSuccess, (state, { clickedOnReviewPerLocation }) => ({ ...state, clickedOnReviewCount: clickedOnReviewPerLocation })),
    on(ReportsActions.getSendEngineEfficiencyPerLocationSuccess, (state, { senEngineEfficiencyPerLocation }) => ({ ...state, sendEngineEfficiency: senEngineEfficiencyPerLocation })),
    on(ReportsActions.getAverageContactSpeedPerLocationSuccess, (state, { averageContactSpeedPerLocation }) => ({ ...state, averageContactSpeed: averageContactSpeedPerLocation })),
    on(ReportsActions.getFeedbackReviewPercentagePerLocationSuccess, (state, { feedbackReviewPercentage }) => ({ ...state, feedbackReviewPercentage: feedbackReviewPercentage })),
    on(ReportsActions.getReviewPerReviewSitePerLocationSuccess, (state, { reviewsPerReviewSite }) => ({ ...state, reviewsPerReviewSite: reviewsPerReviewSite })),
    on(ReportsActions.getRatingPerReviewSitePerLocationSuccess, (state, { ratingPerReviewSite }) => ({ ...state, ratingPerReviewSite: ratingPerReviewSite })),
    on(ReportsActions.getSentRequestCountPerLocationSuccess, (state, { sentRequestCount }) => ({ ...state, sentRequestCount: sentRequestCount })),
    on(ReportsActions.getSentimentCheckCountPerLocationSuccess, (state, { sentimentCheckCount }) => ({ ...state, sentimentCheckCount: sentimentCheckCount })),
    on(ReportsActions.getCampaignMetricsPerLocationSuccess, (state, { campaignMetrics }) => ({ ...state, campaignMetrics: campaignMetrics })),
    on(ReportsActions.setGeneralReportDateRange, (state, { payload }) => ({ ...state, generalReportDateRange: {...state.generalReportDateRange, startTime: payload.startTime, endTime: payload.endTime} })),
    on(ReportsActions.searchScheduledReportsPerBusinessSuccess, (state, { scheduledReports }) => ({ ...state, scheduledReports })),
    on(ReportsActions.deleteScheduledReportSuccess, (state, { id }) => ({ ...state, scheduledReports: state.scheduledReports.filter((report)=>report.id!=id.data)})),
    on(ReportsActions.addScheduledReportToBusinessSuccess, (state, { scheduledReport }) => ({ ...state, scheduledReports: [scheduledReport, ...state.scheduledReports] })),
    on(ReportsActions.editScheduledReportSuccess, (state, { scheduledReport }) => ({ ...state, scheduledReports: state.scheduledReports.map((scheduledReportItem => scheduledReport.id === scheduledReportItem.id ? scheduledReport : scheduledReportItem))})),
    on(ReportsActions.reportsError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState }))
);

export const getTotalGeneratedReports = (state: State) => state.totalgeneratedReports
export const getReportsSettings = (state: State) => state.reportsSettings;
export const getGeneratedReports = (state: State) => state.generatedReports;
export const getRating = (state: State) => state.rating;
export const getStarsCount = (state: State) => state.starsCount;
export const getReviewCount = (state: State) => state.reviewCount;
export const getFeedbackCount = (state: State) => state.feedbackCount;
export const getClickedOnReviewCount = (state: State) => state.clickedOnReviewCount;
export const getSendEngineEfficiency = (state: State) => state.sendEngineEfficiency;
export const getAvergaContactSpeed = (state: State) => state.averageContactSpeed;
export const getFeedbackReviewPercentage = (state: State) => state.feedbackReviewPercentage;
export const getReviewsPerReviewSites = (state: State) => state.reviewsPerReviewSite;
export const getRatingPerReviewSites = (state: State) => state.ratingPerReviewSite;
export const getSentRequestCount = (state: State) => state.sentRequestCount;
export const getSentimentCheckCount = (state: State) => state.sentimentCheckCount;
export const getCampaignMetrics = (state: State) => state.campaignMetrics;
export const getGeneralReportDateRange = (state: State) => state.generalReportDateRange;
export const getScheduledReports = (state: State) => state.scheduledReports;
export const getError = (state: State) => state.error;
